<template>
  <div>
    <data-table
      ref="table"
      :fetch-from="fetchForm"
      :fields="fields"
      @loaded="onTableLoaded"
    >
      <template
        slot="counterpartName"
        slot-scope="slotData"
      >
        {{ slotData.rowData.counterpart_name }}
        <v-chip
          color="red"
          text-color="white"
          label
          small
          v-if="slotData.rowData.counterpart_role_landlord_tenant_name == 'Tenant'"
        >
          {{ slotData.rowData.counterpart_role_landlord_tenant_name }}
        </v-chip>
      </template>

      <template
        slot="powerIncluded"
        slot-scope="slotData"
      >
        {{ slotData.rowData.power_included_in_rent|nullToFalse|formatBool }}
      </template>
      <template
        slot="actions"
        slot-scope="slotData"
      >
        <template v-if="!isReadOnlyLocal()">
          <v-btn
            x-small
            color="primary"
            @click="showEdit(slotData.rowData)"
          >Edit</v-btn>
        </template>&nbsp;
        <template>
          <v-btn
            x-small
            color="primary"
            @click="showDetails(slotData.rowData)"
          >Details</v-btn>
        </template>&nbsp;
        <template>
          <v-btn
            x-small
            color="primary"
            @click="askToDelete(slotData.rowData)"
          >Delete</v-btn>
        </template>

      </template>
    </data-table>
    <v-btn
      v-if="!isReadOnlyLocal()"
      color="primary"
      small
      @click="showAddDialog()"
    >
      Add contract
    </v-btn>
    <confirm-dialog
      v-model="confirmDelete"
      title="Do you realy want to remove cotract?"
      @confirmed="doContractDelete"
    >
      By clicking on confirm button the entry will be deleted and can not be restored.
    </confirm-dialog>
    <modal-form
      title="Contracts"
      :readonly="isReadOnlyLocalModal()"
      :show="dialog"
      :has-subtitle="true"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
      :loading="loading"
    >
      <template v-slot:subtitle>
        <v-row>
          <v-col cols="3">
            <display-field label="Site id">{{ site.site_id_display }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Site name">{{ site.site_name }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Address">{{ contract.address|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Land registry">{{ contract.land_registry|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Cadastral parcel">{{ contract.cadastral_parcel }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Cadastral municipality">{{ contract.cadastral_municipality }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Status">{{ site.status }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Site type">{{ site.type }}</display-field>
          </v-col>
        </v-row>
      </template>

      <template v-slot:additionalActions>

        <template v-if="item.id != null">
          <v-btn
            :loading="loading"
            v-on:click="createSupplementAgreement()"
          >
            Create new supplement agreement
          </v-btn>
        </template>

        <template v-if="item.id != null">
          <v-btn
            :loading="loading"
            v-on:click="createReplaceAgreement()"
          >
            Replace agreement
          </v-btn>
        </template>

      </template>

      <v-form
        v-model="valid"
        ref="form"
      >
          <v-row>
            <v-col cols="4">
              <counterpart
                :readonly="isReadOnlyLocalModal()"
                label="Counterpart"
                :value="getValue(item, 'counterpart')"
                @input="setValue(item, 'counterpart', $event)"
              >
              </counterpart>
            </v-col>
            <v-col cols="4">
              <counterpart-role
                :readonly="isReadOnlyLocalModal()"
                label="Counterpart role"
                :value="getValue(item, 'counterpart_role_landlord_tenant')"
                @input="setValue(item, 'counterpart_role_landlord_tenant', $event)"
              ></counterpart-role>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="Agreement number"
                :value="getValue(item, 'agreement_number')"
                @input="setValue(item, 'agreement_number', $event)"
                hint="Keep blank to assign agreement number automatically"
              ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="SAP agreement number"
                :value="getValue(item, 'sap_agreement_number')"
                @input="setValue(item, 'sap_agreement_number', $event)"
              ></text-field>
            </v-col>
            <v-col cols="4">
              <agreement-type
                :readonly="isReadOnlyLocalModal()"
                label="Agreement type"
                :value="getValue(item, 'agreement_type')"
                @input="setValue(item, 'agreement_type', $event)"
              ></agreement-type>
            </v-col>
            <v-col cols="4">
              <agreement-status
                :readonly="isReadOnlyLocalModal()"
                label="Agreement status"
                :value="getValue(item, 'agreement_status')"
                @input="setValue(item, 'agreement_status', $event)"
              ></agreement-status>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <contractual-period-type
                :readonly="isReadOnlyLocalModal()"
                label="Contractual period type"
                :value="getValue(item, 'contractual_period_type')"
                @input="setValue(item, 'contractual_period_type', $event)"
              ></contractual-period-type>
            </v-col>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnlyLocalModal()"
                label="Lease signed"
                :value="getValue(item, 'lease_signed')"
                @input="setValue(item, 'lease_signed', $event)"
              ></date-picker>
            </v-col>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnlyLocalModal()"
                label="Contract valid from"
                :value="getValue(item, 'contract_valid_from')"
                @input="setValue(item, 'contract_valid_from', $event)"
              ></date-picker>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnlyLocalModal()"
                label="Contract valid to"
                :value="getValue(item, 'contract_valid_to')"
                @input="setValue(item, 'contract_valid_to', $event)"
              ></date-picker>
            </v-col>
            <v-col cols="4">
              <date-picker
                :readonly="isReadOnlyLocalModal()"
                label="Handover date"
                :value="getValue(item, 'handover_date')"
                @input="setValue(item, 'handover_date', $event)"
              ></date-picker>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="Extension period"
                suffix="months"
                :value="getValue(item, 'extension_period')"
                @input="setValue(item, 'extension_period', $event)"
              ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="Notice period"
                suffix="months"
                :value="getValue(item, 'notice_period')"
                @input="setValue(item, 'notice_period', $event)"
              ></text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="Early cancellation clause (owner)"
                :value="getValue(item, 'early_cancellation_clause_owner')"
                @input="setValue(item, 'early_cancellation_clause_owner', $event)"
              ></text-field>
              <day-month-year
                :readonly="isReadOnlyLocalModal()"
                label="Unit"
                :value="getValue(item, 'early_cancellation_clause_owner_unit')"
                @input="setValue(item, 'early_cancellation_clause_owner_unit', $event)"
              ></day-month-year>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="Early cancellation clause (landlord)"
                :value="getValue(item, 'early_cancellation_clause_landlord')"
                @input="setValue(item, 'early_cancellation_clause_landlord', $event)"
              ></text-field>
              <day-month-year
                :readonly="isReadOnlyLocalModal()"
                label="Unit"
                :value="getValue(item, 'early_cancellation_clause_landlord_unit')"
                @input="setValue(item, 'early_cancellation_clause_landlord_unit', $event)"
              ></day-month-year>
            </v-col>
            <v-col cols="4">
              <text-field
                :readonly="isReadOnlyLocalModal()"
                label="Early cancellation penalty"
                :value="getValue(item, 'early_cancellation_penalty')"
                @input="setValue(item, 'early_cancellation_penalty', $event)"
              ></text-field>
              <day-month-year
                :readonly="isReadOnlyLocalModal()"
                label="Unit"
                :value="getValue(item, 'early_cancellation_penalty_unit')"
                @input="setValue(item, 'early_cancellation_penalty_unit', $event)"
              ></day-month-year>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <currency-field
                :readonly="isReadOnlyLocalModal()"
                label="Yearly rent"
                :value="getValue(item, 'yearly_rent')"
                @input="setValue(item, 'yearly_rent', $event)"
              >
              </currency-field>
            </v-col>

            <v-col cols="4">
              <currency-field
                :readonly="isReadOnlyLocalModal()"
                label="Monthly rent"
                :value="getValue(item, 'monthly_rent')"
                @input="setValue(item, 'monthly_rent', $event)"
              >
              </currency-field>
            </v-col>

            <v-col cols="4">
              <currency-unit
                :readonly="isReadOnlyLocalModal()"
                label="Currency unit"
                :value="getValue(item, 'currency_unit')"
                @input="setValue(item, 'currency_unit', $event)"
              ></currency-unit>
            </v-col>

          </v-row>
          <v-row>
            <v-col cols="4">
              <payment-schedule
                :readonly="isReadOnlyLocalModal()"
                label="Payment schedule"
                :value="getValue(item, 'payment_schedule')"
                @input="setValue(item, 'payment_schedule', $event)"
              ></payment-schedule>
            </v-col>
            <v-col cols="4">
              <switch-button
                :readonly="isReadOnlyLocalModal()"
                label="Indexation"
                :value="getValue(item, 'indexation')"
                @change="setValue(item, 'indexation', $event)"
              ></switch-button>
            </v-col>
            <v-col cols="4">
              <switch-button
                :readonly="isReadOnlyLocalModal()"
                label="IOU form"
                :value="getValue(item, 'iou_form')"
                @change="setValue(item, 'iou_form', $event)"
              ></switch-button>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <switch-button
                :readonly="isReadOnlyLocalModal()"
                label="Payment without request"
                :value="getValue(item, 'payment_without_request')"
                @change="setValue(item, 'payment_without_request', $event)"
              ></switch-button>
            </v-col>
            <v-col cols="4">
              <responsible-person-acqusition
                :readonly="isReadOnlyLocalModal()"
                label="responisble person, Acqusition"
                :value="getValue(item, 'responisble_person_acqusition')"
                @input="setValue(item, 'responisble_person_acqusition', $event)"
              ></responsible-person-acqusition>
            </v-col>
            <v-col cols="4">
              <switch-button
                :readonly="isReadOnlyLocalModal()"
                label="IFRS16"
                :value="getValue(item, 'ifrs16')"
                @change="setValue(item, 'ifrs16', $event)"
              ></switch-button>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <switch-button
                :readonly="isReadOnlyLocalModal()"
                label="Power included in rent"
                :value="getValue(item, 'power_included_in_rent')"
                @change="setValue(item, 'power_included_in_rent', $event)"
              ></switch-button>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <h3>Attached files</h3>
              <file-upload
                :readonly="isReadOnlyLocalModal()"
                module="contracts"
                section="agreement_scann"
                :site_id="site.site_id"
                :item_id="itemId"
                :multi="true"
                label="Agreement scann"
                @input="setValue(item, 'scans', $event)"
              ></file-upload>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <s-textarea
                :readonly="isReadOnlyLocalModal()"
                label="Comment"
                :value="getValue(item, 'comments')"
                @input="setValue(item, 'comments', $event)"
              ></s-textarea>
            </v-col>
          </v-row>
      </v-form>
    </modal-form>
  </div>
</template>

<script>
  import TextField from '@/components/TextField'
  import FileUpload from '@/components/FileUpload'
  import AgreementType from '@/components/codelist/AgreementType'
  import AgreementStatus from '@/components/codelist/AgreementStatus'
  import ModalForm from '@/components/ModalForm'
  import ReactivityMixin from '@/mixins/Reactivity'
  import ValidationMixin from '@/mixins/Validation'
  import SiteContractEntryService from '@/services/site-contract-entry'
  import DataTable from '@/components/DataTable'
  import PermissionsMixin from '@/mixins/Permissions'
  import CounterpartRole from '@/components/codelist/CounterpartRole'
  import Counterpart from '@/components/codelist/Counterpart'
  import DatePicker from '@/components/DatePicker'
  import ContractualPeriodType from '@/components/codelist/ContractualPeriodType'
  import DayMonthYear from '@/components/codelist/DayMonthYear'
  import SwitchButton from '@/components/SwitchButton'
  import ResponsiblePersonAcqusition from '@/components/codelist/ResponsiblePersonAcqusition'
  import EmptySpace from '@/components/EmptySpace'
  import CurrencyField from '@/components/CurrencyField'
  import CurrencyUnit from '@/components/codelist/CurrencyUnit'
  import PaymentSchedule from '@/components/codelist/PaymentSchedule'
  import STextarea from '@/components/Textarea'
  import DisplayField from '@/components/DisplayField'
  import ConfirmDialog from '../../../../components/ConfirmDialog.vue'
  export default {
    name: 'Contracts',
    mixins: [
      ReactivityMixin,
      ValidationMixin,
      PermissionsMixin,
    ],
    components: { ConfirmDialog, DisplayField, STextarea, PaymentSchedule, CurrencyUnit, CurrencyField, EmptySpace, ResponsiblePersonAcqusition, SwitchButton, DayMonthYear, ContractualPeriodType, DatePicker, Counterpart, CounterpartRole, DataTable, ModalForm, AgreementStatus, AgreementType, FileUpload, TextField },
    props: {
      site: {
        default: undefined,
      },
      contract: {
        default: undefined,
      },
      forceReadOnly: {
        default: false,
      },
      autoOpen: {
        default: null,
      },
    },
    data: () => ({
      tab: undefined,
      valid: false,
      dialog: false,
      selected_index: -1,
      item: {},
      fields: [
        {
          name: 'agreement_number',
          title: 'Agreement number',
        },
        {
          name: 'agreement_type_name',
          title: 'Agreement type',
        },
        {
          name: 'agreement_status_name',
          title: 'Agreement status',
        },
        {
          name: '__slot:counterpartName',
          title: 'Counterpart',
        },
        {
          name: '__slot:powerIncluded',
          title: 'Power included',
        },
        {
          name: '__slot:actions',
          title: 'Actions',
        },
      ],
      section: 'contract',
      wasAutoLoaded: false,
      showOnlyDetails: false,
      loading: false,
      confirmDelete: false,
      confirmDeleteContractId: undefined,
    }),
    computed: {
      isEditing () {
        return this.item.id !== undefined
      },
      itemId () {
        if (this.item.id) {
          return this.item.id
        }
        return undefined
      },
    },
    methods: {
      isReadOnlyLocal () {
        return this.isReadOnly() || this.forceReadOnly
      },
      isReadOnlyLocalModal () {
        return this.isReadOnlyLocal() || this.showOnlyDetails
      },
      fetchForm (urls, options) {
        const acs = new SiteContractEntryService(this.site.id)
        return acs.list(options.params)
      },
      showAddDialog () {
        this.item = {}
        this.showOnlyDetails = false
        this.dialog = true
      },
      showEdit (item) {
        this.showOnlyDetails = false
        this.item = JSON.parse(JSON.stringify(item))
        this.dialog = true
      },
      showDetails (item) {
        this.showOnlyDetails = true
        this.item = JSON.parse(JSON.stringify(item))
        this.dialog = true
      },
      askToDelete (item) {
        this.confirmDelete = true
        this.confirmDeleteContractId = item.id
      },
      doContractDelete () {
        if (!this.confirmDeleteContractId) {
          return false
        }
        const acs = new SiteContractEntryService(this.site.id)
        acs.delete(this.confirmDeleteContractId).then((response) => {
          this.confirmDeleteContractId = undefined
          this.confirmDelete = false
          this.$refs.table.refresh()
        }).finally(() => {
          this.loading = false
        })
      },
      createSupplementAgreement () {
        this.showOnlyDetails = false
        this.item = JSON.parse(JSON.stringify(this.item))
        delete this.item.id

        if (this.item.agreement_number) {
          const parts = this.item.agreement_number.split(':')
          if (parts[1] === undefined) {
            parts[1] = '0'
          }
          parts[1] = parseInt(parts[1]) + 1
          this.item.agreement_number = parts[0] + ':' + parts[1]
        }
        this.dialog = true
      },
      createReplaceAgreement () {
        this.showOnlyDetails = false
        const createdFrom = this.item.id
        this.item = {}
        this.item.created_from = createdFrom
        this.dialog = true
      },
      doSave () {
        this.validate()
        if (this.valid) {
          this.loading = true
          if (this.isEditing) {
            const acs = new SiteContractEntryService(this.site.id)
            acs.put(this.item.id, this.item).then((response) => {
              this.$refs.table.refresh()
              this.dialog = false
            }).finally(() => {
              this.loading = false
            })
          } else {
            const acs = new SiteContractEntryService(this.site.id)
            acs.post(this.item).then((response) => {
              this.$refs.table.refresh()
              this.dialog = false
            }).finally(() => {
              this.loading = false
            })
          }
        }
      },
      onTableLoaded () {
        if (this.autoOpen != null && !this.wasAutoLoaded) {
          const data = this.$refs.table.getData()
          for (const item of data) {
            if (item.id + '' === this.autoOpen) {
              setTimeout(() => {
                this.wasAutoLoaded = true
                this.showDetails(item)
              }, 200)
              break
            }
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
